import React from 'react'
import PropTypes from 'prop-types'

import { Picture } from '@aok/image'
import { ArrowRoundedRight } from '@aok/icon-functional'

import formatDate from '../../../utils/formatDate'
import { openUrl } from '../../../utils/UrlUtils'
import { PageType } from '../../../utils/defaultTypes'

// List of teasers which can be used by CategoryList, Tag, TopicList and Search page
const TeaserList = ({ context, elements, className }) => {
  return (
    <ul
      className={`teaserList flex flex-col ${
        context === PageType.SEARCH ? 'gap-y-48' : 'gap-y-40 1280:gap-y-48'
      } ${className}`}
    >
      {elements.map((result, index) => {
        return (
          <li key={index}>
            <div
              data-clickable-tile
              role="presentation"
              className={`relative group cursor-pointer 1280:gap-x-32 ${
                context !== PageType.SEARCH
                  ? '600:grid 600:grid-cols-6 600:gap-x-16 720:gap-x-24 840:grid-cols-8'
                  : '1280:flex '
              }`}
              onClick={() => openUrl(result.url)}
            >
              {result.image && (
                <Picture
                  {...result.image}
                  className={`
                    1280:w-280 1280:flex-shrink-0
                    ${
                      context === PageType.SEARCH
                        ? 'hidden 1280:block '
                        : 'block col-span-full mb-24 600:mb-0 600:col-start-1 600:col-end-3 600:flex-shrink-0 840:col-end-4'
                    }
                  `}
                />
              )}

              <div className="col-span-full 600:col-start-3 600:col-end-7 840:col-start-4 840:col-end-9">
                {/* Meta info */}
                {result.releaseDate && result.subtitle && (
                  <p className="mb-8 text-16 leading-24 text-6d767c">{`${formatDate(result.releaseDate)} - ${
                    result.subtitle
                  }`}</p>
                )}

                {/* Title */}
                <a
                  href={result.url}
                  aria-label={`Titel der Seite: ${result.title}`}
                  className="text-20 leading-28 font-semibold text-005e3f group-hover:text-18ab42 focus-visible:text-18ab42"
                >
                  <span aria-hidden={true} dangerouslySetInnerHTML={{ __html: result.title }} />
                  <ArrowRoundedRight className="inline fill-current w-16 h-20 pb-4 ml-4 transition ease-in-out duration-350 group-hover:scale-120" />
                </a>

                {/* Abstract */}
                {result.abstract && (
                  <span
                    className={`text-16 leading-24 ${
                      context !== PageType.SEARCH ? 'hidden 600:block 600:mt-8' : 'block mt-8'
                    }`}
                    dangerouslySetInnerHTML={{ __html: result.abstract }}
                  />
                )}
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

TeaserList.propTypes = {
  context: PropTypes.oneOf([PageType.SEARCH, PageType.CATEGORY, PageType.TAG, PageType.TOPIC]),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      releaseDate: PropTypes.string,
      abstract: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.oneOfType([
        PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
        }),
        PropTypes.shape({
          alt: PropTypes.string,
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string,
              alt: PropTypes.string,
            })
          ),
        }),
      ]),
    })
  ),
  className: PropTypes.string,
}
TeaserList.defaultProps = {
  elements: [],
  className: '',
}

export default TeaserList
